// src/components/DocumentTypeIcon.js
import React from "react";

/* -------------------------------------------------------
 * Yleinen värillinen ikoni (paperi + label)
 * ----------------------------------------------------- */
const ColoredFileIcon = ({ color, label }) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 25,
      height: 30,
      backgroundColor: color,
      borderRadius: 6,
      color: "#fff",
      fontSize: 7,
      fontWeight: 700,
      userSelect: "none",
    }}
  >
    {label}
  </div>
);

/* -------------------------------------------------------
 * PÄÄKOMPONENTTI – tiedostotyypin tunnistus
 * ----------------------------------------------------- */
const DocumentTypeIcon = ({ filename }) => {
  if (!filename) return <ColoredFileIcon color="#777" label="FILE" />;

  const t = filename.toLowerCase().trim();

  /* -------------------------------------------------------
   * KUVA / MEDIA
   * ----------------------------------------------------- */
  if (t.endsWith(".jpg") || t.endsWith(".jpeg"))
    return <ColoredFileIcon color="#FFA726" label="JPG" />;
  if (t.endsWith(".png"))
    return <ColoredFileIcon color="#29B6F6" label="PNG" />;
  if (t.endsWith(".gif"))
    return <ColoredFileIcon color="#AB47BC" label="GIF" />;
  if (t.endsWith(".svg"))
    return <ColoredFileIcon color="#EF6C00" label="SVG" />;
  if (t.endsWith(".tif") || t.endsWith(".tiff"))
    return <ColoredFileIcon color="#5C6BC0" label="TIF" />;
  if (t.endsWith(".raw"))
    return <ColoredFileIcon color="#37474F" label="RAW" />;

  /* -------------------------------------------------------
   * VIDEO
   * ----------------------------------------------------- */
  if (t.endsWith(".mp4"))
    return <ColoredFileIcon color="#EC407A" label="MP4" />;
  if (t.endsWith(".mov"))
    return <ColoredFileIcon color="#8E24AA" label="MOV" />;
  if (t.endsWith(".avi"))
    return <ColoredFileIcon color="#1E88E5" label="AVI" />;

  /* -------------------------------------------------------
   * AUDIO
   * ----------------------------------------------------- */
  if (t.endsWith(".mp3"))
    return <ColoredFileIcon color="#5C6BC0" label="MP3" />;
  if (t.endsWith(".wav"))
    return <ColoredFileIcon color="#66BB6A" label="WAV" />;
  if (t.endsWith(".flac"))
    return <ColoredFileIcon color="#009688" label="FLAC" />;

  /* -------------------------------------------------------
   * OFFICE / PDF / DOC
   * ----------------------------------------------------- */

  // PDF
  if (t.endsWith(".pdf"))
    return <ColoredFileIcon color="#E53935" label="PDF" />;

  // DOCX (sininen Word-ikoni)
  if (t.endsWith(".docx"))
    return <ColoredFileIcon color="#1E5AA8" label="DOCX" />;

  // DOC
  if (t.endsWith(".doc"))
    return <ColoredFileIcon color="#1E5AA8" label="DOC" />;

  // TXT
  if (t.endsWith(".txt"))
    return <ColoredFileIcon color="#90A4AE" label="TXT" />;

  // RTF
  if (t.endsWith(".rtf"))
    return <ColoredFileIcon color="#546E7A" label="RTF" />;

  // PPT
  if (t.endsWith(".ppt") || t.endsWith(".pptx"))
    return <ColoredFileIcon color="#D84315" label="PPT" />;

  // EXCEL
  if (t.endsWith(".xls") || t.endsWith(".xlsx"))
    return <ColoredFileIcon color="#43A047" label="XLS" />;

  // CSV
  if (t.endsWith(".csv"))
    return <ColoredFileIcon color="#66BB6A" label="CSV" />;

  /* -------------------------------------------------------
   * ARKISTOT
   * ----------------------------------------------------- */
  if (t.endsWith(".zip"))
    return <ColoredFileIcon color="#F9A825" label="ZIP" />;
  if (t.endsWith(".rar"))
    return <ColoredFileIcon color="#8E24AA" label="RAR" />;

  /* -------------------------------------------------------
   * OHJELMOINTI / MUUT
   * ----------------------------------------------------- */
  if (t.endsWith(".html"))
    return <ColoredFileIcon color="#AB47BC" label="HTML" />;
  if (t.endsWith(".css"))
    return <ColoredFileIcon color="#42A5F5" label="CSS" />;
  if (t.endsWith(".js"))
    return <ColoredFileIcon color="#FFB300" label="JS" />;
  if (t.endsWith(".json"))
    return <ColoredFileIcon color="#8D6E63" label="JSON" />;
  if (t.endsWith(".xml"))
    return <ColoredFileIcon color="#6D4C41" label="XML" />;
  if (t.endsWith(".php"))
    return <ColoredFileIcon color="#00ACC1" label="PHP" />;

  /* -------------------------------------------------------
   * Oletusikoni (tuntematon tyyppi)
   * ----------------------------------------------------- */
  return <ColoredFileIcon color="#757575" label="FILE" />;
};

export default DocumentTypeIcon;
